module.exports = __webpack_public_path__ + "img/guide13.17db199b.jpg";